import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FiTarget, FiTrendingUp, FiCheckCircle } from 'react-icons/fi';
import './About.css';

const About: React.FC = () => {
  const { t } = useTranslation();

  const highlights = [
    'highlight1',
    'highlight2',
    'highlight3',
    'highlight4'
  ];

  return (
    <section className="about section" id="about">
      <div className="container">
        {/* Ana İçerik - Sol: Fotoğraflar, Sağ: Yazılar + Vizyon/Misyon */}
        <div className="about-main">
          {/* Sol Taraf - Sadece Fotoğraflar */}
          <motion.div 
            className="about-left-section"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            {/* 2 Fotoğraf */}
            <div className="about-images-stack">
              <div className="about-image-wrapper">
                <img src="/hakkimizda.jpeg" alt="Usta Consulting Team" />
              </div>
              <div className="about-image-wrapper">
                <img src="/hakkimizda2.jpeg" alt="Usta Consulting" />
              </div>
            </div>
          </motion.div>

          {/* Sağ Taraf - Yazılar + Vizyon/Misyon + Kapanış */}
          <motion.div 
            className="about-text-section"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="about-intro">{t('about.intro')}</p>
            <p className="about-paragraph">{t('about.paragraph1')}</p>
            <p className="about-paragraph">{t('about.paragraph2')}</p>
            
            <div className="about-highlights">
              {highlights.map((key, index) => (
                <div key={index} className="highlight-item">
                  <FiCheckCircle className="highlight-icon" />
                  <span>{t(`about.${key}`)}</span>
                </div>
              ))}
            </div>

            {/* Vizyon & Misyon */}
            <div className="about-vm-section">
              <div className="vm-card">
                <div className="vm-icon"><FiTarget /></div>
                <h3>{t('about.vision')}</h3>
                <p>{t('about.visionText')}</p>
              </div>
              <div className="vm-card">
                <div className="vm-icon"><FiTrendingUp /></div>
                <h3>{t('about.mission')}</h3>
                <p>{t('about.missionText')}</p>
              </div>
            </div>

            {/* Kapanış ve Slogan */}
            <div className="about-closing-right">
              <p>{t('about.closing')}</p>
              <p className="about-slogan">{t('about.slogan')}</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
